"use client";

import { Flex } from "@chakra-ui/react";
import { FiArrowLeft } from "react-icons/fi";
import { EmptyState } from "@/components/feedback";
import { Button, Link, NavLink, Text } from "@/components/ui";
import { PageTypeGlobal } from "@/lib/types";
import { useThemeTokens } from "@/lib/theme/tokens";

interface TeacherPublicPageErrorProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export const TeacherPublicPageError = ({
  onRetry,
  isRetrying = false,
}: TeacherPublicPageErrorProps) => {
  const theme = useThemeTokens();

  return (
    <EmptyState
      title="Couldn't load this instructor"
      message={
        <Flex direction="column" gap={4} align="center">
          <Text variant="secondary" fontSize="sm" textAlign="center">
            Something went wrong while fetching this profile. Please try again.
          </Text>
          <Flex gap={3} wrap="wrap" justify="center">
            <Button
              variant="primary"
              size="sm"
              data-testid="teacher-public-retry-button"
              onClick={onRetry}
              isLoading={isRetrying}
              isDisabled={isRetrying}
            >
              Try again
            </Button>
            <Link
              as={NavLink}
              fontSize="sm"
              fontWeight="500"
              color={theme.accent.primary}
              href={PageTypeGlobal.Classes}
              display="inline-flex"
              alignItems="center"
              gap={1}
            >
              <FiArrowLeft />
              Back to classes
            </Link>
          </Flex>
        </Flex>
      }
    />
  );
};

export const TeacherPublicPageNotFound = () => {
  const theme = useThemeTokens();

  return (
    <EmptyState
      title="Instructor not found"
      message={
        <Flex direction="column" gap={4} align="center">
          <Text variant="secondary" fontSize="sm" textAlign="center">
            This instructor profile could not be found or is no longer available.
          </Text>
          <Link
            as={NavLink}
            fontSize="sm"
            fontWeight="500"
            color={theme.accent.primary}
            href={PageTypeGlobal.Classes}
            display="inline-flex"
            alignItems="center"
            gap={1}
          >
            <FiArrowLeft />
            Back to classes
          </Link>
        </Flex>
      }
    />
  );
};

export const TeacherPublicPageUnavailable = () => {
  const theme = useThemeTokens();

  return (
    <EmptyState
      title="Profile unavailable"
      message={
        <Flex direction="column" gap={4} align="center">
          <Text variant="secondary" fontSize="sm" textAlign="center">
            This instructor profile isn&apos;t available right now.
          </Text>
          <Link
            as={NavLink}
            fontSize="sm"
            fontWeight="500"
            color={theme.accent.primary}
            href={PageTypeGlobal.Classes}
            display="inline-flex"
            alignItems="center"
            gap={1}
          >
            <FiArrowLeft />
            Back to classes
          </Link>
        </Flex>
      }
    />
  );
};
